<template>
    <v-container fluid fill-height grid-list-md style="background-color:#fafafa">
        <v-form style="width:100%">
            <v-layout text-center wrap align-center justify-center>
                <v-flex xs12 sm12>
                    <h1 class="display-1 my-5">
                        <span class="font-weight-bold">Criadores</span>
                        | Nova Música Gospel
                    </h1>

                    <!--v-btn @click="model=0">INICIAL</v-btn>
                    <v-btn @click="model=1">FINAL</v-btn-->

                    <v-carousel
                        v-model="model"
                        :show-arrows="false"
                        hide-delimiter-background
                        height="auto"
                        hide-delimiters
                        light
                        class="mx-auto my-auto"
                    >
                        <v-carousel-item light class="mx-auto my-auto" wrap>
                            <v-layout class="my-5" grid-list-xl wrap align-center justify-center>
                                <v-flex xs12 sm8 md10 xl8>
                                    <div class="align-left text-left pb-5">
                                        <v-btn to="/" class="elevation-0" icon>
                                            <v-icon>mdi-arrow-left</v-icon>
                                        </v-btn>
                                    </div>
                                    <v-card class="elevation-1 px-3">
                                        <v-card-title
                                            style="color:#616161"
                                            v-if="artista.professional_name"
                                            :error-messages="errors.collect('artist_name')"
                                        >Informações Profissionais</v-card-title>

                                        <v-card-text>
                                            <v-text-field
                                                label="Nome artistíco"
                                                name="nome_artistico"
                                                type="text"
                                                v-model="artista.professional_name"
                                                hint="Nome pelo qual você, ou sua dupla ou banda é conhecida ou gostaria de ser conhecida."
                                                v-validate="'required'"
                                                data-vv-name="artistic_name"
                                                :error-messages="errors.collect('artistic_name')"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>

                                <v-fade-transition>
                                    <v-flex
                                        xs12
                                        sm8
                                        md10
                                        xl8
                                        py-3
                                        v-if="artista.professional_name"
                                        transition="scroll-y-reverse-transition"
                                    >
                                        <v-card class="elevation-1 px-3">
                                            <v-card-title style="color:#616161">Informações Pessoais</v-card-title>

                                            <v-card-text>
                                                <v-layout wrap grid-list-xl>
                                                    <v-flex xs12 md6>
                                                        <v-text-field
                                                            label="Primeiro Nome"
                                                            name="pessoal_nome"
                                                            type="text"
                                                            v-model="artista.firstname"
                                                            hint="Nome utilizado em seus documentos."
                                                            v-validate="'required'"
                                                            data-vv-name="first_name"
                                                            :error-messages="errors.collect('first_name')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 md6>
                                                        <v-text-field
                                                            label="Sobrenome"
                                                            name="pessoal_sobrenome"
                                                            type="text"
                                                            v-model="artista.lastname"
                                                            hint="Sobrenome utlizado em seus documentos."
                                                            v-validate="'required'"
                                                            data-vv-name="last_name"
                                                            :error-messages="errors.collect('last_name')"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 md4>
                                                        <v-text-field
                                                            label="CPF"
                                                            name="pessoal_cpf"
                                                            type="text"
                                                            v-model="artista.cpf"
                                                            hint="Esse campo é necessário para garantir que você receba o pagamentos corretamente."
                                                            v-validate="'required|cpfcheck'"
                                                            data-vv-name="cpf"
                                                            :error-messages="errors.collect('cpf')"
                                                            v-mask="$globalformmasks.cpf"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 md4>
                                                        <v-menu
                                                            ref="menu"
                                                            v-model="menu"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="formated_date"
                                                                    label="Data de nascimento"
                                                                    readonly
                                                                    v-on="on"
                                                                    @keypress="data_nascimento_focado"
                                                                    v-validate="'required'"
                                                                    data-vv-name="dob"
                                                                    :error-messages="errors.collect('dob')"
                                                                    ref="data_nascimento"
                                                                    
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                locale="pt-br"
                                                                ref="picker"
                                                                v-model="date"
                                                                :max="new Date().toISOString().substr(0, 10)"
                                                                min="1930-01-01"
                                                                @change="saveDate"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                    </v-flex>

                                                    <v-flex xs12 md4>
                                                        <v-text-field
                                                            label="Celular"
                                                            name="pessoal_cellphone"
                                                            type="text"
                                                            v-model="artista.cellphone"
                                                            hint="Utilize o seu número de celular ou um no qual conseguimos contato direto."
                                                            v-validate="'required'"
                                                            data-vv-name="cellphone"
                                                            :error-messages="errors.collect('cellphone')"
                                                            v-mask="$globalformmasks.cellphone"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 md6>
                                                        <v-text-field
                                                            label="E-mail"
                                                            v-validate="'required|email'"
                                                            data-vv-name="email"
                                                            :error-messages="errors.collect('email')"
                                                            name="pessoal_email"
                                                            type="text"
                                                            v-model="artista.email"
                                                            hint="Utilize um e-mail válido para receber corretamente as comunicações de pagamento, relatórios, notas e recibos."
                                                            autocomplete="username"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 md6>
                                                        <v-text-field
                                                            label="Confirme seu e-mail"
                                                            v-validate="'required|email'"
                                                            data-vv-name="email_confirm"
                                                            :error-messages="errors.collect('email_confirm')"
                                                            name="pessoal_email"
                                                            type="text"
                                                            v-model="artista.email_confirm"
                                                            hint="Digite novamente o seu e-mail."
                                                            autocomplete="username"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <!--v-divider></v-divider-->
                                                    </v-flex>

                                                    <v-flex xs12 md6>
                                                        <v-text-field
                                                            label="Senha"
                                                            name="pessoal_senha"
                                                            type="password"
                                                            v-model="artista.password"
                                                            hint="Digite uma senha com no minimo de 8 caracteres entre letras e números."
                                                            autocomplete="new-password"
                                                            v-validate="'required|min:8'"
                                                            data-vv-name="password"
                                                            :error-messages="errors.collect('password')"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 md6>
                                                        <v-text-field
                                                            label="Confirme a sua senha"
                                                            name="pessoal_senha_confirma"
                                                            type="password"
                                                            v-model="artista.password_confirm"
                                                            hint="Digite novamente a sua senha."
                                                            autocomplete="new-password"
                                                            v-validate="'required'"
                                                            data-vv-name="password_confirm"
                                                            :error-messages="errors.collect('password_confirm')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    :to="{name:'cadastro'}"
                                                    class="elevation-0"
                                                    text
                                                    color="primary"
                                                    @click="continuar_contrato()"
                                                >Continuar</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-flex>
                                </v-fade-transition>
                            </v-layout>
                        </v-carousel-item>

                        <v-carousel-item class="mx-auto my-auto">
                            <v-layout wrap grid-list-xl align-center justify-center>
                                <v-flex xs12 sm8 md6 xl6>
                                    <div class="align-left text-left pb-5">
                                        <!--v-btn @click="model=0" class="elevation-0" icon>
                      <v-icon>mdi-arrow-left</v-icon>
                                        </v-btn-->
                                    </div>
                                    <v-card class="elevation-1 my-5 px-3">
                                        <v-card-title
                                            style="color:black; text-align:center!important;display:block"
                                            class="text-center align-center py-5"
                                        >Você está dentro!</v-card-title>

                                        <v-card-text>
                                            <p>
                                                Acabamos de enviar um e-mail de confirmação para você. <br>
                                                Mas não se preocupe em confirma-lo agora. :)<br>
                                                Entre no portal e veja tudo o que temos para te oferecer!
                                            </p>
                                            <v-layout wrap>
                                                <v-flex xs12 offset-sm-3 sm6>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        :to="{name:'login'}"
                                                    >CONTINUAR</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-carousel-item>
                    </v-carousel>
                </v-flex>
            </v-layout>
        </v-form>
        <modalmessage
            ref="modalmessage"
            @btn_1_clicked="modalmessage_entendi"            
            @btn_2_clicked="modalmessage_recuperar_senha"
        />

        <v-row justify="center">
    <v-dialog v-model="show_contract" scrollable  width="800px">
      
      <v-card>
        <v-card-title>
          <span class="headline text-center">Leia e aceite os termos do contrato para continuar. </span>
        </v-card-title>
        <v-card-text style="height: 500px;">
<strong>CONTRATO DE LICENCIAMENTO DE FONOGRAMA E/OU VIDEOFONOGRAMA</strong>
<br/>
<br/>MK EDIÇÕES MUSICAIS LTDA, inscrita no CNPJ sob o nº 03.199.269/0001-37, com sede na Rua Gotemburgo, 211, São Cristóvão, Rio de Janeiro, CEP 20.941-080, neste ato denominada NOVA MÚSICA GOSPEL autoriza com o presente contrato que o LICENCIANTE utilize, acesse os serviços e softwares da NOVA MÚSICA GOSPEL.
<br/>
<br/>Nossos serviços e o presente contrato estão de acordo com as diretrizes da Lei Geral de Proteção de Dados- Lei 13.709/2018 (<a href="http://www.planalto.gov.br/ccivil_03/_Ato2015-2018/2018/Lei/L13709compilado.htm">http://www.planalto.gov.br/ccivil_03/_Ato2015-2018/2018/Lei/L13709compilado.htm</a>)
<br/>
<br/>Ao assinar este contrato e utilizar ou acessar os serviços da NOVA MÚSICA GOSPEL, o LICENCIANTE  concorda com todos os termos e condições previstos neste contrato.
<br/>
<br/>Considerando que o LICENCIANTE é o legítimo e único detentor dos direitos patrimoniais dos fonogramas e/ou videofonogramas e este, possui o interesse de distribuir seus fonogramas e/ou videofonogramas por meio da NOVA MÚSICA GOSPEL.
<br/>
<br/>A NOVA MÚSICA GOSPEL é uma plataforma destinada, com exclusividade, à distribuição, licenciamento e sublicenciamento de conteúdo de fonogramas e/ou videofonogramas, via internet, através de seu website, incluindo mas não se limitando a plataforma e serviços de terceiros que podem vir a existir ou a ser desenvolvidos após a data efetiva, data esta, contado da assinatura do presente contrato.
<br/>
<br/>Resolvem, portanto as partes firmar o presente Contrato de Licenciamento de fonogramas e/ou videofonogramas, que será regido pelas Cláusulas e condições a seguir estabelecidas.
<br/>
<br/><strong>CLÁUSULA PRIMEIRA- DO OBJETO E TERRITÓRIO</strong>
<br/>
<br/>1.1 O presente contrato tem como objeto a licença exclusiva concedida pelo LICENCIANTE à NOVA MÚSICA GOSPEL, dos direitos de reprodução, publicação, distribuição, comunicação ao público, exploração comercial, exibição, transmissão/retransmissão, inclusão em base de dados/ armazenamento e promoção dos fonogramas e/ou videofonogramas do LICENCIANTE, isoladamente ou em conjunto, através de qualquer meio, mídia, modo, processo, ou suporte digital e/ou eletrônico, que permita utilização na modalidade citada, independente de tecnologia do sistema de distribuição digital em plataformas de <em>streamings </em>e <em>downloads</em>.
<br/>
<ul>
 	<li>A licença objeto deste contrato concede a NOVA MÚSICA GOSPEL igualmente o direito de modificar e adaptar tecnicamente os fonogramas e/ou videofonogramas sem qualquer alteração no conteúdo afim de que a NOVA MÚSICA GOSPEL possa se adequar aos eventuais requisitos técnicos de envio de conteúdo dos serviços/lojas digitais, sem que isso represente qualquer ofensa ao direito do LICENCIANTE nos fonogramas e/ou videofonogramas.</li>

 	<li>O LICENCIANTE está ciente que o upload do fonograma será distribuido, mediante pagamento conforme informação no site, para todas as plataformas no qual a NOVA MÚSICA GOSPEL tenha contrato ou parceria, e esta só estará disponível nas plataformas em até 20 dias corridos.</li>

 	<li>Caso o LICENCIANTE tenha um videofonograma e queira divulgar pelo canal da NOVA MÚSICA GOSPEL, este poderá ser divulgado após passar pela curadoria artística da NOVA MÚSICA GOSPEL, somente após a aprovação que o LICENCIANTE irá realizar o pagamento, conforme informação no site, pelo upload do vídeofonograma aprovado.</li>

    <li>A NOVA MÚSICA GOSPEL poderá explorar livremente o fonograma e/ou videofonograma, diretamente ou através de terceiros com os quais venha a contratar, podendo, ainda, proibir e/ou autorizar, sublicenciar a terceiros, no território brasileiro e no exterior, todos os direitos a ela garantidos por força deste instrumento, pelo prazo e nas condições constantes neste contrato.</li>
</ul>

<br/><strong>CLÁUSULA SEGUNDA- DA EXCLUSIVIDADE DOS SERVIÇOS/ LOJAS DIGITAIS E DIREITO DE PREFERÊNCIA</strong>
<br/>
<br/>2.1     O LICENCIANTE assegura a NOVA MÚSICA GOSPEL o direito exclusivo durante a vigência deste contrato, de sublicenciar todo o seu conteúdo (Single, EP, álbum ou vídeo), para fins de distribuição, comunicação ao público, exploração comercial, exibição e transmissão/retransmissão dos fonogramas e/ou viodeofonogramas. Deste modo, o LICENCIANTE não poderá licenciar, ceder ou garantir os direitos concedidos a NOVA MÚSICA GOSPEL para qualquer terceiros, por qualquer título ou motivo.
<br/>
<br/>2.2 Havendo a possibilidade de contratação artística por outrem, o LICENCIANTE desde já concede a MK MUSIC, empresa do grupo MK de Comunicação, preferência para a contratação artístico-musical, quando comunicado acerca de propostas de terceiros interessados. A NOVA MÚSICA GOSPEL terá o prazo de 15 (quinze) dias contados do efetivo recebimento do comunicado para analisar e avaliar as propostas. Caso a NOVA MÚSICA GOSPEL não se manifeste no prazo acima determinado, este perderá o direito de preferência, ficando o LICENCIANTE livre para negociações e assinaturas.
<br/>
<br/><strong>CLÁUSULA TERCEIRA-DECLARAÇÕES E GARANTIAS DE DIREITO</strong>
<br/><br/>
3.1  As partes declaram (I) que têm todo o poder e autoridade para entrar e executar este contrato, (ii) a execução e desempenho das suas obrigações e que este contrato não constituem uma infração ou conflito com qualquer outro contrato ou acordo pelo qual o LICENCIANTE ou a NOVA MÚSICA GOSPEL estão vinculados, e (iii) estes termo é uma obrigação legal, válida e vinculativa as partes.<br/><br/>
3.2  O LICENCIANTE garante que não violará os direitos autorais, marca registrada, patente, segredo comercial, direito de privacidade, direito de publicidade ou outro direito legal de quaisquer terceiros e irá cumprir todas as leis aplicáveis, normas e regulamentos.<br/><br/>
3.3  O LICENCIANTE não poderá realizar regravações de um fonograma previamente gravado (cover) ou utilizar algum produto (por exemplo playback) produzido por terceiros sem a devida autorização.<br/><br/>
3.4  O LICENCIANTE declara e garante à NOVA MÚSICA GOSPEL que: (i) não há reclamações, demandas ou qualquer forma de litígios pendentes ou, no melhor de seu conhecimento, ameaçadas de litígios com relação a qualquer fonograma e/ou videofonograma.<br/><br/>
3.5 O LICENCIANTE, por meio deste contrato, garante à NOVA MÚSICA GOSPEL o direito irrevogável de sublicenciar seu conteúdo em todo o território (nacional e internacional), na vigência deste termo, garante e declara, ainda:
<br/><br/>
<ul>
    <li>a) O direito exclusivo e licença para converter, digitalizar, anexar, integrar, codificar ou reproduzir os fonogramas e/ou videofonogramas em plataformas digitais de <em>streaming </em>e <em>download</em>, que existam ou que venham a existir, com o intuito de distribuir, como estabelecido neste contrato.</li>
	<li>b) O direito exclusivo e licença para distribuir digitalmente o conteúdo, reproduzir, transmitir, licenciar, vender (incluindo sem limitação via download, streaming, serviços de assinatura e outros), anunciar, publicar, fazer anúncios publicitários, transmitir ou de qualquer forma usar e explorar os vídeofonogramas em qualquer formato digital ou eletrônico, atual ou futuro, na vigência deste acordo, aos consumidores em todo o território (nacional e internacional), através de alguma plataforma ou serviços semelhantes prestados por terceiros, incluindo, mas não limitando ao site (distribuição direta), plataformas ou serviços de plataformas de terceiros, sendo certo que tais direitos devem incluir o direito de explorar, produzir, exibir, reproduzir e distribuir imagens e/ou trechos dos vídeos em separado.</li>
 	<li>c) O direito e licença para transmitir o conteúdo, no todo ou em parte, como amostra a título gratuito, com o intuito de inserir e atrair usuários que façam o “download” do conteúdo. O LICENCIANTE concorda que nenhum royalty ou pagamento (incluindo, mas não limitado ao uso da composição musical) deve ser acumulado, e, portanto, não serão pagos, no que concerne às visualizações de amostras dos conteúdos transmitidos gratuitamente. Para evitar dúvidas, as visualizações das amostras poderão ser disponibilizadas no site ou em site de terceiros, dessa forma o usuário terá permissão apenas para ouvir/assistir a amostra, mas não para fazer o download;</li>
 	<li>d) O direito exclusivo e licença para gerenciar e administrar a exploração comercial de fonogramas e/ou videofonogramas postados por terceiros (“UGC”), que incorpore o seu conteúdo na Internet, via YouTube ou de outra forma, incluindo, sem limitação, a gestão do Content ID do YouTube com relação aos conteúdos permitindo o rastreamento, monetização, retirada ou bloqueio de tal UGC na Internet (Content ID").</li>
 	<li>e) O direito e licença sem qualquer tipo de remuneração ao LICENCIANTE, o direito de difundir a imagem, voz, nome, nome artístico e marca do LICENCIANTE, sincronizar, incluir, reproduzir os fonogramas e/ou videofonogramas, para fins de publicação, promoção e/ou publicidade da distribuição dos fonogramas e/ou videofonogramas, seja para a NOVA MÚSICA GOSPEL, seja pelas lojas/ serviços digitais sublicenciados, inclusive de forma associada a parceiros comerciais.</li>
 	<li>f) O direito e licença para explorar os fonogramas e/ou videofonogramas, necessários ao cumprimento deste contrato. O LICENCIANTE deverá informar no ato do cadastro na plataforma da NOVA MÚSICA GOSPEL, o nome do autor de cada obra que será objeto deste contrato. Na hipótese do LICENCIANTE não possuir legitimamente tais licenças, ou não ser o mesmo o titular originário das composições, o LICENCIANTE deverá, sob sua exclusiva responsabilidade, obter todas as licenças e autorizações necessárias para este fim.</li>
 	<li>g) O direito não exclusivo, sujeito a prévia aprovação escrita pelo LICENCIANTE em cada instância (e-mail poderá ser suficiente), para a NOVA MÚSICA GOSPEL licenciar e fazer com que outros licenciem o uso, exploração e execução do conteúdo e na medida em que sejam propriedade ou controlada pelo LICENCIANTE, quanto à composição musical nele incorporado, incluindo, sem limitação, a sincronização das músicas e as composições musicais (se aplicáveis), em conjunto com filmes, programas de televisão, anúncios, vídeo games e qualquer outro trabalho audiovisual. E ainda, no âmbito da sincronização, concede licença para a NOVA MÚSICA GOSPEL arrecadar todas as receitas decorrentes da exploração das músicas e composições musicais (excluindo execução pública) que delas decorram.</li>
 	<li>h) A menos que de outro modo aqui especificado, os termos acima expostos garantem que os direitos são exclusivos em todo o território nacional e internacional, durante o prazo de vigência deste contrato e dos demais firmados pela NOVA MÚSICA GOSPEL, de modo que o LICENCIANTE não deve licenciar, ceder ou garantir os direitos acima concedidos à NOVA MÚSICA GOSPEL para qualquer terceiro, por qualquer título e motivo, durante a vigência deste acordo, na extensão do território ajustado neste instrumento. O LICENCIANTE reconhece e concorda, desde já, que a NOVA MÚSICA GOSPEL possa utilizar, contratar e subcontratar terceiros para o exercício dos direitos acima concedidos a ela, sem prejuízo deste contrato.</li>
 	<li>i) Que pode demonstrar e comprovar à NOVA MÚSICA GOSPEL os direitos e licenças ora licenciados, sendo legítimo ou detentor de tais direitos.</li>
</ul>
<br/>3.6 O LICENCIANTE será responsável pela elaboração de todo material de divulgação e publicidade. Caso, a NOVA MÚSICA GOSPEL elabore algum material de divulgação, a seu exclusivo critério, mas não se limitando a posters, display, logotipos, entre outros, serão de única e exclusiva propriedade da NOVA MÚSICA GOSPEL, e não poderá ser utilizados pelo LICENCIANTE ou terceiros, sem prévia e expressa autorização.
<br/>
<br/>3.7 O LICENCIANTE garante e responde, em qualquer caso, civil e criminalmente pela veracidade, exatidão e autenticidade dos dados cadastrados. Caso haja violação ou suspeita de violação de direitos de terceiros, o LICENCIANTE declara-se ciente que a NOVA MÚSICA GOSPEL poderá fazer o <em>takedown</em> sem que nenhum tipo de ressarcimento.
<br/>
<br/>3.8 Será de exclusiva responsabilidade do LICENCIANTE verificar a qualidade do áudio e se o upload foi devidamente realizado. Devendo este, ter um backup de todos os áudios que serão disponibilizados na NOVA MÚSICA GOSPEL.
<br/>
<br/><strong>CLÁUSULA QUARTA- DA REMUNERAÇÃO E RELATÓRIO</strong>
<br/>
<br/>4.1 Como retribuição pelo licenciamento dos fonogramas e/ou videofonogramas, a NOVA MÚSICA GOSPEL pagará ao LICENCIANTE 70% (setenta por cento) da receita líquida efetivamente recebida pela NOVA MÚSICA GOSPEL dos serviços e lojas digitais sublicenciados, obtida por estes com a exploração comercial dos fonogramas e/ou videofonogramas.
<br/>
<br/>4.1.1 Entende-se por Receita Líquida o montante real que a NOVA MÚSICA GOSPEL receber dos parceiros digitais atribuído à venda, licença, exploração e uso dos fonogramas e/ou videofonogramas, deduzidos impostos, taxas administrativas, taxa de processamento, transferências bancárias, taxas de banco, venda ou qualquer operação, taxas de câmbio ou tarifas de processamento incorridas pela transferência de valores ao LICENCIANTE.
<br/>
<br/>4.2 O LICENCIANTE será exclusivamente responsável pelo pagamento de qualquer terceiro que possa ter tais diretos sobre o fonogramas e/ou videofonogramas licenciados, tais como autores, músicos, arranjadores, intérpretes, iluminadores, editores, produtores, músicos, artistas convidados ou qualquer terceiro envolvido.
<br/>
<br/>4.3 Obrigatoriamente toda obra utilizada no fonograma e/ou videofonograma, objeto deste contrato, devará estar Editada para o recebimento de Direito Autoral em plataformas digitais. Caso a obra já esteja editada, o autor deverá verificar com a respectiva editora o pagamento do referido direito. Porém, se a obra não estiver editada, a NOVA MÚSICA GOSPEL poderá oferecer esse serviço de edição, através do e-mail autoral@novamusicagospel.com.br.
<br/>
<br/>4.4 Todo serviço que o LICENCIANTE contratar, no qual estará disponível no site, a NOVA MÚSICA GOSPEL deverá emitir Nota Fiscal. As contribuições e impostos decorrentes da operação contratada serão incluídas no valor final da Nota Fiscal.
<br/>
<br/>4.5 A NOVA MÚSICA GOSPEL pagará mensalmente, em razão da exploração comercial dos fonogramas e/ou videofonogramas, em até 30 (trinta) dias após o fechamento do mês do calendário civil, desde que o montante devido ao LICENCIANTE seja superior a R$50,00 (cinquenta reais).
<br/>
<br/>4.6 O relatório financeiro consolidado estará disponível na plataforma da NOVA MÚSICA GOSPEL.
<br/>
<br/><strong>CLÁUSULA QUINTA- ATIVIDADES FRAUDULENTAS, DELITUOSAS OU ILÍCITAS E INDENIZAÇÃO</strong>
<br/>
<br/>5.1 Se a NOVA MÚSICA GOSPEL receber qualquer notificação reclamando de que os fonogramas e/ou videofonogramas ou qualquer informação ou material fornecido pelo LICENCIANTE estão violando os direitos de terceiros (como direitos autorais, patrimoniais, marcas registradas, direitos de publicidade ou outros direitos de propriedade intelectual), ou que o LICENCIANTE não está cumprindo qualquer de suas obrigações nos termos do presente contrato, inclusive qualquer licença ou acordo relativo aos fonogramas e/ou videofonogramas, a NOVA MÚSICA GOSPEL informará ao LICENCIANTE e poderá, a seu critério exclusivo, remover os fonogramas e/ou videofonogramas ou outras informações e materiais, até que o usuário forneça evidência suficiente, a critério exclusivo da NOVA MÚSICA GOSPEL, de que qualquer problema do gênero, relacionado às reclamações em questão, tenha sido solucionado.
<br/>
<br/>5.2 Fica expressamente ajustado o direito de regresso da NOVA MÚSICA GOSPEL contra o LICENCIANTE, na hipótese da NOVA MÚSICA GOSPEL incorrer em qualquer custo ou despesa, por ter o LICENCIANTE descumprido qualquer das obrigações que este contrato lhe atribuam, direito esse que obrigará o LICENCIANTE a reembolsar à NOVA MÚSICA GOSPEL do valor despendido, incluindo custas e honorários advocatícios, corrigido monetariamente, segundo o índice de variação do IGP-M/FGV (índice Geral de Preços do Mercado).
<br/>
<br/>5.3 O LICENCIANTE se compromete, tão logo tenha notícia, por simples comunicado escrito da NOVA MÚSICA GOSPEL ou por qualquer outro meio, de reclamação ou postulação contra a NOVA MÚSICA GOSPEL, judicial ou não, nos termos desta cláusula, deverá intervir voluntariamente na mesma, assumindo a exclusividade do pólo passivo de tal reclamação ou postulação, além de reembolsar a NOVA MÚSICA GOSPEL de despesas, incluindo custas e honorários advocatícios, já por esta incorridas. A obrigação ora assumida pelo LICENCIANTE aplicar-se-á em qualquer reclamação ou postulação de terceiros contra a NOVA MÚSICA GOSPEL, desde seu início, independentemente de culpa e das eventuais alegações que tenham o LICENCIANTE e a NOVA MÚSICA GOSPEL sobre tal reclamação ou postulação. Aplicar-se-á também independentemente da qualificação jurídica do terceiro reclamante ou postulante. Em qualquer caso judicial, não havendo a LICENCIANTE ainda assumido a exclusividade de responder pela reclamação ou postulação de terceiro, poderá a  NOVA MÚSICA GOSPEL, se demandada sozinha, valer-se dos competentes institutos de intervenção de terceiro, especialmente o da denunciação da lide, para fazer valer a presente estipulação.

<br/>
<br/>5.4 O LICENCIANTE manterá a NOVA MÚSICA GOSPEL, seus empregados, afiliados, diretores, executivos, licenciados e subdistribuidores indene de quaisquer danos, perdas ou despesas, incluindo, sem limitação honorários advocaticios, custas e despesas judiciais, decorrentes ou relacionadas a qualquer violação ou alegação de violação de direitos de terceiros, praticadas pelo LICENCIANTE acerca de qualquer direito, representação ou acordo firmado neste termo. Á partir do momento em que uma demanda judicial prosposta ou eventual ação for proposta, a NOVA MÚSICA GOSPEL poderá reter o pagamento da receita, no todo ou em parte, devido ao LICENCIANTE, até o montante equivalente à demanda judicial.
<br/>
<br/>5.5 A NOVA MÚSICA GOSPEL não será responsável por danos indiretos e lucros cessantes em qualquer hipótese.
<br/>
<br/>5.6 A responsabilidade da NOVA MUSICA GOSPEL por qualquer ação relacionada a este acordo não excederá o montante do valor pago por esta ao proprietário durante 12 (doze) meses anteriores à data do inadimplemento ou infração geradora da eventual demanda.
<br/>
<br/><strong>CLÁUSULA SEXTA- VIGÊNCIA E RESCISÃO</strong>
<br/>
<br/>6.1 O prazo de vigência deste Contrato será de 02 (dois) anos, contados a partir do lançamento do primeiro produto, renovando-se automaticamente por 01 ano sucessivamente, podendo ser rescindido por escrito por qualquer uma das partes com antecedência de  30 (trinta) dias, sempre antes do final do período corrente.
<br/>
<br/>6.2 Este contrato poderá ser declarado rescindido caso qualquer parte entre em processo de recuperação judicial ou extrajudicial, falência ou se ocorrer violação de qualquer de suas disposições, se a parte infratora não cessar a infração dentro de 30 (trinta) dias corridos, contados da data do recebimento da notificação.
<br/>
<br/>6.3 A NOVA MÚSICA GOSPEL poderá a qualquer momento rescindir de forma motivada o presente contrato com o LICENCIANTE, caso seja constatado que o LICENCIANTE (I) infringiu ou possa vir a infringir qualquer direito de terceiro, (II) causar qualquer prejuízo a NOVA MÚSICA GOSPEL ou trazer descrédito a companhia ou (III) por qualquer razão que a NOVA MÚSICA GOSPEL interprete como justificadora.

<br/>
<br/><strong>CLÁUSULA SÉTIMA- NOTIFICAÇÃO</strong>
<br/>
<br/>7.1 Todas as notificações, avisos, citações, intimações, problemas, reclamações e quaisquer outros dados requeridos ou necessários entre as Partes deverá ser feitos por escrito no endereço indicado a seguir e será considerada recebida quando acusado o recebimento ou comprovado seu recebimento:
<br/>
<br/><strong>NOVA MÚSICA GOSPEL - GRUPO MK DE COMUNICAÇÃO</strong>
<br/>
<br/>Rua Gotemburgo, 211, São Cristóvão, Rio de Janeiro, CEP 20.941-080.
<br/>
<br/>E-mail: contato@novamusicagospel.com.br
<br/>
<br/>Tel.:(21)3891-9300
<br/>
<br/><strong>CLÁUSULA OITAVA- DISPOSIÇÕES GERAIS</strong>
<br/>
<br/>8.1 O LICENCIANTE se compromete a não ceder ou transferir o presente contrato ou qualquer dos direitos e obrigações aqui previstos a qualquer terceiro, sem o consentimento prévio por escrito da NOVA MÚSICA GOSPEL, a critério exclusivo desta última. Nenhuma forma de cessão ou delegação por parte do LICENCIANTE o isentará de suas obrigações sob o presente Contrato. Sujeitos às disposições acima, o presente Contrato será vinculativo às partes e reverter-se-á em benefício de cada Parte e de seus respectivos sucessores e cessionários.
<br/>
<br/>8.2 Fica expressamente estipulado que não se estabelece entre as Partes, por força deste termo, nenhuma relação de sociedade, associação, consórcio, representação, agência, <em>joint venture</em>, vínculo trabalhista ou responsabilidade subsidiária ou solidária.
<br/>
<br/>8.3 A eventual invalidade, nulidade ou não exequibilidade de qualquer dispositivo contratual não afetará as demais disposições deste instrumento, as quais continuarão válidas e exequíveis, devendo a cláusula declarada nula ou inaplicável ser substituída por outra que conduza as Partes ao mesmo resultado econômico e jurídico almejado.
<br/>
<br/>8.4 As Partes obrigam-se por si, seus herdeiros ou sucessores ao fiel cumprimento deste Termo.
<br/>
<br/>8.5 O presente Contrato será regido e interpretado pelas leis aplicáveis no Brasil. As partes, pelo presente, concordam e se submetem de forma irrevogável à jurisdição do Tribunal da Comarca Central do Estado do Rio de Janeiro com o competente para a resolução de todos os assuntos  e/ou controvérsias que sejam decorrentes do presente Termo, com a exclusão de qualquer outro, por mais privilegiado que seja.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="show_contract = false">Não aceito</v-btn>
          <v-btn color="green darken-1" text @click="continuar()">Aceito</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
    </v-container>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import RegisterService from "../../app/Rest/register";
import  '../../app/general'
//components
import modalmessage from "../../components/shared/modalmessage";

var registerService = null;

Vue.use(VeeValidate);

export default {
    $_veeValidate: {
        validator: "new"
    },
    components: {
        modalmessage
    },
    data: () => ({        
        date: null, 
        show_contract:false,
        menu: false,
        artista: { name: "" },
        model: 0,
        dictionary: {
            attributes: {
                email: "E-mail Address"
                // custom attributes
            },
            custom: {
              cpf:{
                  required: "O CPF é obrigatório."
                },
                dob:{
                  required: "A data de nascimento é obrigatório."
                },
                artistic_name: {
                    required: "O nome profissional é obrigatório."
                },
                first_name: {
                    required: "O primeiro nome é um campo obrigatório."
                },
                last_name: {
                    required: "Sobrenome é um campo obrigatório."
                },
                cellphone: {
                    required: "Celular é um campo obrigatório."
                },
                email: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                },
                email_confirm: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                },
                password: {
                    required: "Senha é um campo obrigatório.",
                    min: "Sua senha deve ter no minimo 8 caracteres."
                },
                password_confirm: {
                    required: "Confirmar a senha é um campo obrigatório."
                }
            }
        }
    }),
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        }
    },
    created() {
        registerService = RegisterService.build();
    },
    mounted() {
        this.$validator.localize("pt_br", this.dictionary);
        //this.cover = this.product.cover;
    },
    updated: function() {
        //this.email = "";
        //this.password = "";
    },
    computed: {
        enable_continue_button: function() {
            return this.$validator.validateAll();
        },
        formated_date: function() {
            return this.formatDate(this.date);
        }
    },
    methods: {
    data_nascimento_focado(e){
        this.$refs.data_nascimento.$listeners.click(e);
    },
      modalmessage_recuperar_senha(){
        //this.message.dialog_opened = false;
        this.$router.push({name:'login'});
      },
      modalmessage_entendi(){
        //this.message.dialog_opened = false;
        //this.$refs.modalmessage.
      },
      continuar_contrato(){
          this.$validator.validateAll().then(isvalid => {
                if (!isvalid) {
                    return;
                }

                if(this.artista.email != this.artista.email_confirm){
                this.$refs.modalmessage.show("Atenção aos campos!", 'Os campos de e-mail e confirme o seu e-mail estão diferentes.', "Entendi");
                //  this.message.title = "Atenção aos campos!";
                 // this.message.message = ;
                 // this.message.dialog_opened = true;
                  return;
                }

                if(this.artista.password != this.artista.password_confirm){
                  //this.message.title = "Atenção aos campos!";
                  this.$refs.modalmessage.show("Atenção aos campos!", "Os campos de senha e confirme a sua senha estão diferentes.", "Entendi");
                  //this.message.message = 'Os campos de senha e confirme a sua senha estão diferentes.';
                  //this.message.dialog_opened = true;
                  return;
                }


             this.show_contract = true;
             
          });
      },
        continuar() {
            this.show_contract  = false;
            this.$validator.validateAll().then(isvalid => {
                if (!isvalid) {
                    return;
                }

                if(this.artista.email != this.artista.email_confirm){
                this.$refs.modalmessage.show("Atenção aos campos!", 'Os campos de e-mail e confirme o seu e-mail estão diferentes.', "Entendi");
                //  this.message.title = "Atenção aos campos!";
                 // this.message.message = ;
                 // this.message.dialog_opened = true;
                  return;
                }

                if(this.artista.password != this.artista.password_confirm){
                  //this.message.title = "Atenção aos campos!";
                  this.$refs.modalmessage.show("Atenção aos campos!", "Os campos de senha e confirme a sua senha estão diferentes.", "Entendi");
                  //this.message.message = 'Os campos de senha e confirme a sua senha estão diferentes.';
                  //this.message.dialog_opened = true;
                  return;
                }
                
                this.$store.dispatch("loading_full");
                registerService.create(this.artista).then(e => {
                    if (e.status == "ok") {
                        this.model = 1;
                         window.scrollTo(0,0);
                    } else {
                                             
                        if(e.inl=='register_email_exist'){                          
                          this.$refs.modalmessage.show("Ops ...", e.msg, "Entendi" , "RECUPERAR SENHA");   
                        }else{
                            this.$refs.modalmessage.show("Ops ...", e.msg, "Entendi");   
                        }
                        
                    }
                }).catch(e =>{
                    this.$refs.modalmessage.show("Tivemos um problema", "Aguarde alguns minutos e tente criar a sua conta novamente.", "Entendi");  
                }).finally( ()=>{
                    
                    this.$store.dispatch("loading_full", false);
                });
            });
        },
        saveDate(date) {
            this.artista.dob = date;
            this.$refs.menu.save(this.formatDate(date));
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
    }
};
</script>
